import React from "react";

const RouteChevronIcon = (props) => (
  <svg
    preserveAspectRatio="none"
    overflow="visible"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M8.33333 15.8333C8.13862 15.8337 7.94993 15.7659 7.8 15.6417C7.71562 15.5717 7.64587 15.4858 7.59474 15.3888C7.54361 15.2919 7.51212 15.1858 7.50205 15.0766C7.49199 14.9675 7.50356 14.8574 7.53609 14.7528C7.56863 14.6481 7.6215 14.5509 7.69167 14.4667L11.425 10L7.825 5.525C7.75578 5.43976 7.70409 5.34168 7.67289 5.2364C7.6417 5.13111 7.63162 5.0207 7.64324 4.91151C7.65485 4.80232 7.68793 4.69651 7.74058 4.60014C7.79322 4.50378 7.86439 4.41877 7.95 4.35C8.03622 4.27414 8.13719 4.21691 8.24658 4.18192C8.35596 4.14693 8.4714 4.13493 8.58564 4.14667C8.69989 4.1584 8.81047 4.19363 8.91046 4.25013C9.01044 4.30663 9.09767 4.38319 9.16667 4.475L13.1917 9.475C13.3142 9.62411 13.3812 9.81115 13.3812 10.0042C13.3812 10.1972 13.3142 10.3842 13.1917 10.5333L9.025 15.5333C8.9414 15.6342 8.83521 15.7139 8.71503 15.766C8.59486 15.8181 8.46409 15.8412 8.33333 15.8333Z" fill="#0D3B66"/>
    </g>
  </svg>
);

export default RouteChevronIcon;
